import React, { useCallback, useEffect, useState } from 'react';
import Header from '../components/header';
import SearchIcon from '@mui/icons-material/Search';
import CustomTable from '../components/customTable';
import getEnvironement from '../../environnement';
import axios from 'axios';
import EditIcon from '@mui/icons-material/Edit';
import AddCommentIcon from '@mui/icons-material/AddComment';
import DeleteIcon from '@mui/icons-material/Delete';
import { CircularProgress, IconButton, Tooltip } from '@mui/material';
import StatutDialog from './components/statutDialog';
import { useDispatch, useSelector } from 'react-redux';
import { userSelector } from '../../store/userSlice';
import { useLocation, useNavigate } from 'react-router-dom';
import CommentaireDialog from './components/commentaireDialog';
import { toast, ToastContainer } from 'react-toastify';
import DeleteDialog from './components/deleteDialog';
import { setLang } from '../../store/langSlice';

export default function Reservations() {
  const [searchByName, setSearchByName] = useState('');
  const [reservations, setReservations] = useState([]);
  const [filtredReservations, setFiltredReservation] = useState(reservations);
  const [selectedReservation, setSelectedReservation] = useState();
  const [openStatutDialog, setOpenStatutDialog] = useState(false);
  const [openCommentaireDialog, setOpenCommentaireDialog] = useState(false);
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [isLoader, setIsLoader] = useState(true);

  const [badgeNotification, setBadgeNotification] = useState(0);
  const [reservationsNotification, setReservationsNotification] = useState([]);
  const [messagesNotification, setMessagesNotification] = useState([]);

  const user = useSelector(userSelector);
  const location = useLocation();
  const [localState, setLocalState] = useState(location?.state);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const getReservations = useCallback(async () => {
    setIsLoader(true);
    const url = `${getEnvironement().API_URL}/reservations`;
    await axios.get(url)
      .then((res) => setReservations(res.data.reservations))
      .then(() => setIsLoader(false))
      .catch(() => setIsLoader(false));
  }, [setReservations]);

  function getConfirmation(isConfirmed) {
    if (isConfirmed === 1) {
      return (<span className='w-3 h-3 rounded-full bg-primary inline-block'></span>);
    } else if (isConfirmed === 0) {
      return (<span className='w-3 h-3 rounded-full border border-primary inline-block'></span>);
    } else {
      return (<span />);
    }
  }

  function getStatut(statut) {
    if (statut === 'En cours') {
      return (<span className='bg-primary text-white px-5 rounded-full inline-block whitespace-nowrap'>En cours</span>);
    } else if (statut === 'Rejeté') {
      return (<span className='text-primary inline-block'>Rejeté</span>);
    } else {
      return 'Accepté';
    }
  }

  async function getNotificationData() {
    const url = `${getEnvironement().API_URL}/notificationData`;
    await axios.post(url)
      .then((res) => {
        setReservationsNotification(res.data.reservations);
        setMessagesNotification(res.data.messages);
      })
      .then(() => setBadgeNotification(reservationsNotification.length + messagesNotification.length))
      .catch(() => {});
  }

  useEffect(() => {
    dispatch(setLang('fr'));
  }, [dispatch]);

  useEffect(() => {
    setBadgeNotification(reservationsNotification.length + messagesNotification.length);
  }, [reservationsNotification, messagesNotification]);

  useEffect(() => {
    getNotificationData();
  }, [reservations]);

  useEffect(() => {
    getNotificationData();
  }, []);

  useEffect(() => {
    setFiltredReservation(reservations);
    setSearchByName('');
  }, [reservations]);

  useEffect(() => {
    if (localState?.fromDemandeSalle) {
      toast.success('La demande de réservation de salle a bien été enregistrée');
      setLocalState((prevState) => { return {...prevState, fromDemandeSalle: false}});
    }
  });

  useEffect(() => {
    getReservations();
  }, [getReservations]);

  useEffect(() => {
    if (user === null) {
      navigate('/admin');
    }
  }, [navigate, user]);

  return (
    <div className='h-screen flex flex-col'>
      <ToastContainer />
      <StatutDialog
        open={openStatutDialog}
        handleClose={() => setOpenStatutDialog(false)}
        reloadData={getReservations}
        reservation={selectedReservation}
        getNotificationData={getNotificationData}
      />
      <CommentaireDialog
        open={openCommentaireDialog}
        handleClose={() => setOpenCommentaireDialog(false)}
        reloadData={getReservations}
        reservation={selectedReservation}
        getNotificationData={getNotificationData}
      />
      <DeleteDialog
        open={openDeleteDialog}
        handleClose={() => setOpenDeleteDialog(false)}
        reloadData={getReservations}
        reservation={selectedReservation}
        getNotificationData={getNotificationData}
      />
      <div className='h-38'>
        <Header
          activeItem='Réservations'
          reservations={reservationsNotification}
          messages={messagesNotification}
          badgeNotification={badgeNotification}
        />
      </div>
      <div className='w-full 3xl:flex 3xl:justify-center flex-grow'>
      <div className='3xl:w-[1200px] px-10 py-5 3xl:py-5 3xl:px-0 h-full flex flex-col justify-center'>
          <p className='font-bold text-2xl mb-5'>liste des demandes de réservation de salle :</p>
          <div className='sm:grid grid-cols-4 items-center gap-5'>
            <div className='border-2 border-primary rounded-[20px] flex mb-5 items-center col-start-1 col-end-3 xl:col-end-4'>
              <SearchIcon sx={{color: '#A31732', marginLeft: '20px'}} fontSize='large'/>
              <input
                placeholder='Chercher par formateur'
                className='w-full font-inter font-medium text-2xl my-2 mx-5 focus:outline-none'
                onChange={(e) => {
                  setFiltredReservation(reservations.filter(demande => demande.formateur.includes(e.target.value)));
                }}
              />
            </div>
            <div
              className='group rounded-[20px] py-3 mb-5 cursor-pointer bg-primary hover:bg-primaryDark col-start-3 xl:col-start-4 col-end-5'
              onClick={() => navigate('/demande-salle')}
            >
              <p className='font-medium px-2 text-xl w-full text-center text-white'>Ajouter une réservation</p>
            </div>
          </div>
          <div className=''>
            <CustomTable
              headers={[
                'ID',
                'CIN',
                'département',
                'formateur',
                'assistant formateur',
                'programme',
                'matériel',
                'consommables',
                'nombre participant',
                'type apprentis',
                'date réservation',
                'periodes réservation',
                'statut',
                'commentaire',
                'confirmation',
                'actions'
              ]}
            >
              <tbody>
                {
                  filtredReservations.map((item, index) => {
                    return (
                      <tr key={index} className='border-b-2 border-gray'>
                        <td className='text-center font-medium text-xl py-2'>{item.numero_demande}</td>
                        <td className='text-center font-medium text-xl py-2'>{item.cin}</td>
                        <td className='text-center font-medium text-xl py-2'>{item.departement?.departement}</td>
                        <td className='text-center font-medium text-xl py-2'>{item.formateur}</td>
                        <td className='text-center font-medium text-xl py-2'>{item.assistantFormateur}</td>
                        <td className='text-center font-medium text-xl py-2'>{item.programmeFormation}</td>
                        <td className='text-center font-medium text-xl py-2'>{item.materiel?.materiel}</td>
                        <td className='text-center font-medium text-xl py-2'>
                          {item.consommables.map((i, index) => {
                            return (<p key={index}>{i.consommable}</p>);
                          })}
                        </td>
                        <td className='text-center font-medium text-xl py-2'>{item.nombre_participant}</td>
                        <td className='text-center font-medium text-xl py-2'>{item.type_apprentis}</td>
                        <td className='text-center font-medium text-xl py-2'>{item.date_reservation}</td>
                        <td className='text-center font-medium text-xl py-2'>
                          {JSON.parse(item.periode_reservation).map((item, index) => {
                            return (<p key={index}>{item}</p>);
                          })}
                        </td>
                        <td className='text-center font-medium text-xl py-2'>{getStatut(item.statut)}</td>
                        <td className='text-center font-medium text-xl py-2'>{item.commentaire?.commentaire ?? ''}</td>
                        <td className='text-center font-medium text-xl py-2 allign-middle'>{getConfirmation(item.confirmed)}</td>
                        <td className='text-center font-medium text-xl py-2'>
                          <div className='flex justify-center items-center'>
                            <Tooltip title="Modifier le statut">
                              <IconButton onClick={() => {
                                setSelectedReservation(item);
                                setOpenStatutDialog(true);
                              }}
                              >
                                <EditIcon sx={{color: 'black'}}/>
                              </IconButton>
                            </Tooltip>
                            <Tooltip title="Ajouter un commentaire">
                              <IconButton onClick={() => {
                                setSelectedReservation(item);
                                setOpenCommentaireDialog(true);
                              }}
                              >
                                <AddCommentIcon sx={{color: 'black'}}/>
                              </IconButton>
                            </Tooltip>
                            <Tooltip title="Supprimer cette demande">
                              <IconButton onClick={() => {
                                setSelectedReservation(item);
                                setOpenDeleteDialog(true);
                              }}
                              >
                                <DeleteIcon sx={{color: 'black'}}/>
                              </IconButton>
                            </Tooltip>
                          </div>
                        </td>
                      </tr>
                    );
                  })
                }
                {reservations.length === 0 && (
                  <div className='border-dashed border-4 border-primary rounded-[30px] p-5 mx-10 my-8 hidden xl:inline-block fixed w-[65vw] md:w-[80vw] lg:w-[85vw]'>
                    <p className='font-inter text-primary font-bold text-xl text-center'>
                      {isLoader ? (<CircularProgress open={isLoader} sx={{color: '#A31732'}}/>) : 'Aucune demande de réservation de salle'}
                    </p>
                  </div>
                )}
              </tbody>
            </CustomTable>
          </div>
        </div>
      </div>
    </div>
  );
}
